"use client";
import Image from "next/image";
import { Typography } from "./ui/typography";
import { Button } from "./ui/button";
import Animation from "./ui/animation";
import { scrollAnimationHeader } from "@/constants/motion.variant";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { ProfilePopover } from "./common/proflie-popover";
import { useAuthDialogStore } from "@/hooks/use-auth-dialog";
import useAuth from "@/hooks/use-auth";
import { useAuthStore } from "@/store/use-auth-store";

const Navbar = () => {
  const pathname = usePathname();
  const { signIn } = useAuthDialogStore();
  const { signOutUser } = useAuth();
  const user = useAuthStore((state) => state.user);

  const isAuth = !!user?.isAuthenticated;

    
  return (
    <div className="flex w-full justify-center max-sm:hidden z-50">
      <Animation
        className="fixed bottom-5 border p-1 rounded-2xl flex gap-3 z-30 bg-[#1E1D1D]"
        variants={scrollAnimationHeader}
        viewPortAmount={0.5}
      >
        <Image
          src="/images/logo.webp"
          width={64}
          height={64}
          alt="Plusmongolia logo"
        />
        <div className="flex justify-center items-center gap-3">
          {navItems.map((item, index) => {
            const isActive = pathname === item.href;
            return (
              <Link key={index} href={item.href} scroll={true}>
                <Typography
                  className={`font-semibold text-white py-1 px-2 rounded-lg transition-colors ${
                    isActive ? "bg-[#FFFFFF0D]" : "hover:bg-[#FFFFFF0D]"
                  }`}
                >
                  {item.label}
                </Typography>
              </Link>
            );
          })}
        </div>
        {!isAuth && (
          <Button
            className="px-14 h-full py-5 font-semibold rounded-[12px]"
            onClick={signIn.openDialog}
          >
            <Typography className="font-semibold text-white rounded-lg">
              Нэвтрэх
            </Typography>
          </Button>
        )}
        {isAuth && <ProfilePopover signOut={signOutUser} user={user} />}
      </Animation>
    </div>
  );
};

export default Navbar;

const navItems = [
  {
    label: "Нүүр",
    href: "/",
  },
  {
    label: "Арилжааны сигнал",
    href: "/trading-signal",
  },
  {
    label: "Цахим ном",
    href: "/ebook",
  },
  {
    label: "Видео хичээл",
    href: "/video-course",
  },
];
